(function () {
  if (window.__rootsGuaranteeInit) return;
  window.__rootsGuaranteeInit = true;

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-rgt-root]:not(.rgt-js)').forEach(function (root) {
      root.classList.add('rgt-js');
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('rgt-in');
              io.disconnect();
            }
          });
        },
        { threshold: 0.25 }
      );
      io.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
